import { ConferenceMemberRemovedByOtherEvent, ConferenceRemovedByOtherEvent } from '@wui/im'

import router from '@/app/router'
import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { useChatMessageStore } from '@/entities/messages/chat/model'

import { emitter } from '@/shared/services/emitter'
import { EmitterEvents } from '@/shared/types/emitter-events'
import { Room } from '@/shared/types/store'
import { CHAT, PREPARE_TO_CALL } from '@/shared/utils/constants'
import { fromPServedUser } from '@/shared/utils/uri'
import { getChatRouteId } from '@/shared/utils/url'

export const useChatCleanupHook = (room: Room, event: ConferenceRemovedByOtherEvent | ConferenceMemberRemovedByOtherEvent) => {
  const currentRoute = router.currentRoute.value
  const { removeRoom } = useStoreRooms()
  const { deleteMessages } = useChatMessageStore()
  const executor = fromPServedUser(event.executor)

  deleteMessages(event.pServed)
  removeRoom(room.id)
  if ([CHAT, PREPARE_TO_CALL].indexOf(currentRoute.name as string) >= 0 && currentRoute.params.id === getChatRouteId(room)) { // Если мы находимся на странице чата
    router.push({ name: 'Main' })
    if (event.type === 'ConferenceMemberRemoved') {
      const targetNumber = event.targetNumber
      const isIAm = executor === targetNumber
      if (!isIAm) {
        emitter.emit(EmitterEvents.REMOVE_MEMBER, {
          name: room.name,
        })
      }
    }
  } else { // Если мы не находимся на странице чата
    if (event.type === 'ConferenceRemoved') {
      emitter.emit(EmitterEvents.DELETE_ROOM, {
        name: room.name,
      })
    } else if (event.type === 'ConferenceMemberRemoved') {
      const targetNumber = event.targetNumber
      const isIAm = executor === targetNumber
      if (!isIAm) {
        emitter.emit(EmitterEvents.REMOVE_MEMBER, {
          name: room.name,
        })
      }
    }
  }
}
